exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infl-fe__styles__flashing___QcKkW {\n  animation: infl-fe__styles__pulse___p2yQA 1s infinite;\n}\n\n@keyframes infl-fe__styles__pulse___p2yQA {\n  50% { opacity: 0 }\n}\n", ""]);

// Exports
exports.locals = {
	"flashing": "infl-fe__styles__flashing___QcKkW",
	"pulse": "infl-fe__styles__pulse___p2yQA"
};